import { parse } from 'path-data';

/**
 * @param {string} svgStr
 * @returns {string} SVG DataURL
 */
export const svgAsDataURL = (svgStr) => {
  svgStr = svgStr.replace(/<br>/g, '<br />').replace(/&nbsp;/g, '\u00A0');
  return `data:image/svg+xml;base64,${btoa(unescape(encodeURI(svgStr)))}`;
};

/**
 * @param {string} svg path string
 * @returns {Array<{type: string, values: number[]}>} array of path commands
 */
export const parsePathStr = (pathStr) => {
  try {
    return parse(pathStr, { normalize: true });
  } catch (e) {
    console.log(e);
  }
  return [];
};

/**
 * @param {Array<{type: string, values: number[]}>} commands path commands
 * @returns {Path2D} canvas path
 */
export const pathFromCommands = (commands) => {
  let p = new Path2D();
  commands.forEach((cmd) => {
    switch (cmd.type) {
      case 'M':
        p.moveTo(...cmd.values);
        break;
      case 'L':
        p.lineTo(...cmd.values);
        break;
      case 'C':
        p.bezierCurveTo(...cmd.values);
        break;
      case 'Z':
        p.closePath();
    }
  });
  return p;
};

/**
 * Naive min/max bounds from the segment endoints. It does not include curvature bounds.
 * @param {Array<{type: string, values: number[]}>} commands path commands
 * @returns {{x:number, y:number, width:number, height:number}} bounds
 */
export const pathBounds = (commands) => {
  let [x0, y0] = [Infinity, Infinity];
  let [x1, y1] = [-Infinity, -Infinity];
  commands.forEach((cmd) => {
    let len = cmd.values.length;
    if (!len) return;
    let x = cmd.values[len - 2];
    let y = cmd.values[len - 1];
    x0 = Math.min(x0, x);
    x1 = Math.max(x1, x);
    y0 = Math.min(y0, y);
    y1 = Math.max(y1, y);
  });
  return { x: x0, y: y0, width: x1 - x0, height: y1 - y0 };
};
